<template>
  <div class="sp-template">
    <div class="h-title">充值</div>
    <el-card class="box-card">
      <el-form :model="form" size="small">
        <el-row>
          <el-col :span="10">
            <el-form-item label="当前余额" :label-width="formLabelWidth">￥888</el-form-item>
            <el-form-item label="充值金额" :label-width="formLabelWidth">
              <el-input v-model.lazy="form.test" placeholder="充值金额">
                <template slot="prepend">￥</template>
              </el-input>
            </el-form-item>
            <el-form-item label="支付方式" :label-width="formLabelWidth">
              <el-radio v-model="form.radio" label="1">微信</el-radio>
              <el-radio v-model="form.radio" label="2">支付宝</el-radio>
              <el-radio v-model="form.radio" label="3">银行转账</el-radio>
            </el-form-item>
          </el-col>
        </el-row>
        <el-form-item :label-width="formLabelWidth">
          <el-button size="small" type="primary">确 定</el-button>
        </el-form-item>
      </el-form>
    </el-card>
  </div>
</template>

<script>
export default {
  data() {
    return {
      form: { test: "", radio: "1" },
      customer: [{ name: "666", value: "001" }, { name: "777", value: "002" }],
      formLabelWidth: "120px",
    };
  },
  components: {},
  created() {
  },
  computed: {
  },
  methods: {
  }
};
</script>

<style lang="scss" scoped>

</style>


// WEBPACK FOOTER //
// src/views/accountingcenter/recharge.vue